import React from 'react';
import { CircularProgress, Grid, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  wrapper: {
    height: '100vh',
  },
});

const FullPageSpinner = () => {
  const classes = useStyles({});
  return (
    <Grid
      container
      className={classes.wrapper}
      direction="row"
      justifyContent="center"
      alignItems="center"
    >
      <CircularProgress size={300} />
    </Grid>
  );
};

export default FullPageSpinner;
